import React, {useState, useEffect} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Rewards from './pages/Rewards';
import { QueryClientProvider, useQuery } from '@tanstack/react-query'
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { BrowserRouter, Routes, Route } from "react-router";
import { mockTelegramEnv, postEvent, init, miniApp, retrieveLaunchParams } from '@telegram-apps/sdk';
import { initDataDefault, useStartParam, usePlatform } from "./utils/telegram"
import { useAtom, useSetAtom, useAtomValue } from 'jotai'
import { useApi } from "./utils/api"
import { selectedLangAtom, activeTabAtom, queryClient, personalRefCodeAtom } from "./utils/states"
import telegramAnalytics from '@telegram-apps/analytics';
import { TonConnectUIProvider } from '@tonconnect/ui-react';


(async () => {try {
  await telegramAnalytics.init({
    token: 'eyJhcHBfbmFtZSI6InN3aXBlYXBwIiwiYXBwX3VybCI6Imh0dHBzOi8vdC5tZS9hcHBzd2lwZV9ib3QiLCJhcHBfZG9tYWluIjoiaHR0cHM6Ly9zd2lwZWFwcC5jYy8ifQ==!Tpk87A1BObuY+0uOnliPQJ84A+iKWcdWo6QdZyiqU5s=',
    appName: 'swipeapp',
  })
} catch(e) {} finally {}})().then(_ => {});

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: {
          "continue": "Continue",
          "swipe right demo": "Swipe right, \r\nIf you like",
          "swipe demo 2": "Swipe Left to Skip and Right to Like"
        },
      },
      ru: {
        translation: {
          "continue": "Продолжить",
          "swipe right demo": "Свайпай вправо, \r\nЕсли понравилось",
          "swipe demo 2": "Пропустить - влево, понравилось - вправо"
        }
      }
    },
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });

const root = ReactDOM.createRoot(document.getElementById('root'));

function AppGlobalLoader() {
  return (
    <div className='h-[100vh] w-[100vw] text-white flex flex-col justify-center items-center text-center' />
  )
}

function TelegramPostInit({ children }) {
  const startParam = useStartParam();
  const platform = usePlatform();
  const {requestAccountInit} = useApi();
  const setAccRef = useSetAtom(personalRefCodeAtom);
  const setLang = useSetAtom(selectedLangAtom);
  const setTab = useSetAtom(activeTabAtom);

  useEffect(_ => {
    if (platform && platform !== 'tdesktop' && platform !== 'macos' && platform !== 'weba' && platform !== 'webb') {
      postEvent('web_app_request_fullscreen');
    }
    postEvent('web_app_setup_swipe_behavior', { allow_vertical_swipe: false });
    postEvent('web_app_set_background_color', { color: '#000000' });
    postEvent('web_app_set_bottom_bar_color', { color: '#000000' });
    postEvent('web_app_set_header_color', { color: '#000000' });
  }, [platform]);

  const { isLoading, data } = useQuery({
    queryKey: ['account'],
    queryFn: () => {
      let params = {};
      if (startParam && startParam.referal) {
        params.share = startParam.referal;
      }
      if (startParam && startParam.code) {
        params.ref = startParam.code;
      }
      console.log(params);
      return requestAccountInit(params).then(acc => {
        if (acc && acc.ref) {
          setAccRef(acc.ref);
        }
        if (acc) {
          if (acc.Language === "") {
            setTab("language");
          } else {
            setLang(acc.Language);
          }
        }
        return acc;
      })
    },
  });

  useEffect(_ => {
    if (
      miniApp.setHeaderColor.isAvailable()
      && miniApp.setHeaderColor.supports('rgb')
    ) {
      miniApp.setHeaderColor('#000000');
    }
    if (miniApp.setBackgroundColor.isAvailable()) {
      miniApp.setBackgroundColor('#000000');
    }
  }, [miniApp]);

  console.log(data);

  if (isLoading) return <AppGlobalLoader />;

  return <>{children}</>
}

function TelegramInit({ children }) {
  const [ready, setReady] = useState(false);
  const telegramLaunch = _ => {
    mockTelegramEnv(initDataDefault);
    init();
  };
  useEffect(_ => {
      telegramLaunch();
      setReady(true);
  }, []);
  if (!ready) return <AppGlobalLoader />;
  return <>{children}</>
}


root.render(
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <TonConnectUIProvider manifestUrl={`https://swipeapp.cc/tonconnect-manifest.json`}>
        <TelegramInit>
          <TelegramPostInit>
            <Routes>
              <Route path="/" element={<App />} />
              <Route path="/rewards" element={<Rewards />} />
            </Routes>
          </TelegramPostInit>
        </TelegramInit>
      </TonConnectUIProvider>
    </QueryClientProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
